import { render, staticRenderFns } from "./AmbulatoryTables.vue?vue&type=template&id=0bcb0b80&scoped=true&"
import script from "./AmbulatoryTables.vue?vue&type=script&lang=js&"
export * from "./AmbulatoryTables.vue?vue&type=script&lang=js&"
import style0 from "./AmbulatoryTables.vue?vue&type=style&index=0&id=0bcb0b80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcb0b80",
  null
  
)

export default component.exports